<template>
  <div class="background resume">
    <div class="turn-back" @click="back">
      <svg
        t="1583775585559"
        viewBox="0 0 1024 1024"
        version="1.1"
        p-id="1132"
        width="36"
        height="36"
      >
        <path
          d="M711.841477 976.738462l88.300308-86.171569L404.393354 513.969231 800.141785 137.371569 711.841477 51.2 227.796677 513.969231 711.841477 976.738462z"
          p-id="1133"
          fill="#ffffff"
        />
      </svg>
    </div>
    <div class="content">
      <img class="head" src="../../assets/head.jpg" alt="head-img" />
      <h3>L.YQ</h3>
      <div class="whatsup">创意源于生活。</div>
    </div>
    <div class="cv">
      简历被隐藏
    </div>
    <div class="cv" v-if="false">
      <div class="block">
        <div class="title">Hi，我叫李煜泉，</div>
        <div class="section">
          <p>互联网从业人员，对互联网保持着敏感性和关注度，熟悉产品开发流程，具备一定的项目开发和管理经验。</p>
          <p>喜爱拍照、打羽毛球，闲暇时间会画画。</p>
          <p>长期活跃于摄影社区和技术论坛，偶尔外出走走，探寻创意之源。</p>
        </div>
      </div>
      <div class="block">
        <div class="title">个人信息</div>
        <div class="info">
          <div>李煜泉 | 男 | 26</div>
          <div>广东轻工职业技术学院 | 计算机信息管理</div>
          <div>web前端开发 | 3.5年工作经验</div>
        </div>
      </div>
      <div class="block">
        <div class="title">技能描述</div>
        <div class="section pot">
          <p>熟练运用HTML+CSS+JS，能制作兼容性良好的PC和HTML5页面。</p>
          <p>熟练使用VueJS全家桶开发，曾做过4个中、1个大型基于该技术的项目。</p>
          <p>熟悉微信小程序开发，开发过小程序商城。</p>
          <p>熟悉主流的UI库，比如element，Vant，Vux等。</p>
          <p>能独立开发JS/JQuery插件，曾开发过图片裁切并上传和表单验证插件。</p>
          <p>会用原生JS制作简单的Canvas游戏和动画，如五子棋。</p>
          <p>对electron有一定了解，曾做过一个windows平台的音乐播放器。</p>
          <p>熟练NodeJS，对MySQL和NGINX有一定了解，能独立部署线上网站，曾基于express独立开发搭建了个人博客，前端支持响应式浏览。</p>
        </div>
      </div>
      <div class="block">
        <div class="title">工作经验</div>
        <div class="datetime">2018年5月-2019年11月</div>
        <div class="company">广州玖晔网络</div>
        <div class="sub">（互联网/服务型） web前端工程师</div>
        <div class="section pot">
          <p>负责公司的产品和外包项目的前端模块化开发。包含有PC端、微信小程序、移动端HTML5开发。</p>
          <p>运用当前主流的VueJS、Nodejs开发官网（响应式）、手机商城（web/小程序）活动平台h5等项目、混合式APP、后台管理系统开发、参与大数据分析项目开发。</p>
        </div>

        <div class="datetime">2016年6月-2018年1月</div>
        <div class="company">广东睿哲信息技术有限公司</div>
        <div class="sub">（电商/服务型） web前端工程师</div>
        <div class="section pot">
          <p>负责对公司OIS系统（类似OA）、电商后台管理系统进行前端的开发与维护。</p>
          <p>负责节假日前端开发。例如：双十一/双十二作战大屏、年会互动大屏、手机微信签到与投票、大屏弹幕和特效。</p>
        </div>
      </div>
      <div class="block">
        <router-link class="more" to="/works">更多→</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "resume",
  methods: {
    back() {
      history.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
@keyframes opacity {
  from {opacity: 0;}
  to {opacity: 1;}
}

.resume::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.resume {
  // height: 55rem;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
  &::before {
    background-image: url("../../assets/background/cover-3.jpg");
  }
  .content {
    width: 100%;
    height: 18rem;
    margin-top: 3rem;
    text-align: center;
    vertical-align: middle;
    .head {
      width: 5.6rem;
      height: 5.6rem;
      border-radius: 50%;
      border: 0.25rem solid #fff;
      margin-top: 2rem;
    }
    .whatsup {
      color: #607080;
      font-weight: lighter;
    }
  }
  .cv {
    width: 80%;
    max-width: 50rem;
    min-height: 55rem;
    background-color: rgba(255, 255, 255, 0.8);
    margin: 0 auto;

    .block {
      .section {
        font-weight: lighter;
        padding: 1rem 2.6rem;
        p {
          margin: 0.5rem;
        }
        &.pot > p::before {
          content: "● ";
          color: skyblue;
        }
      }
      .title {
        font-size: 1rem;
        font-weight: bold;
        padding: 1rem;
        &:first-child {
          padding-top: 2.6rem;
        }
      }
      .info {
        display: flex;
        justify-content: space-between;
        font-weight: lighter;
        padding: 1rem 2.6rem;
      }
      div {
        flex-wrap: wrap;
      }

      .datetime {
        color: olivedrab;
        padding: 0 1rem 0.5rem;
      }
      .company,
      .sub {
        padding: 0.5rem 1.5rem 0;
      }

      &>.more {
        display: block;
        padding: 2rem 3rem;
        text-align: right;
        text-decoration: none;
      }
    }
  }
  .turn-back {
    display: none;
    margin-top: 1rem;
    margin-left: 0.6rem;
  }
}

.resume::before {
    content: "";
    width: 100%;
    height: 100%;
    background-image: url("../../assets/background/cover-2.jpg");
    background-size: cover;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    // -webkit-filter: blur(3px);
    // filter: blur(3px);
    animation: opacity 3s forwards; /*animation-fill-mode*/
}

@media screen and (max-width: 420px) {
  .cv {
    width: 100% !important;
  }
  .resume .turn-back {
    display: block;
  }
  .resume .content {
    margin-top: 2rem;
  }
  .resume::before {
    animation: none;
  }
}
</style>